import React from 'react'
import { useTranslation } from 'react-i18next'
import { Callout, RowsSkeletonLoader } from '@node-space/ui-components'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { ProtocolContextProvider } from 'contexts/protocolContext'
import { useWalletContext } from 'hooks/context'
import { usePrepareNewlyCreatedCryptoWallet } from 'pages/WalletDetails/hooks/usePrepareNewlyCreatedCryptoWallet'
import { CopyAllDetailsCrypto } from './CopyAllDetailsCrypto'
import { ProtocolsRadioButtons } from './ProtocolsRadioButtons'
import { WalletAddressDetails } from './WalletAddressDetails'
import { WalletQrCode } from './WalletQrCode'
import { WarningMessage } from './WarningMessage'

export const CryptoExtendedDetails = () => {
  const wallet = useWalletContext()
  const { isError, isPending } = usePrepareNewlyCreatedCryptoWallet()
  const { t } = useTranslation()
  if (isPending) {
    return <RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />
  }
  if (isError) {
    return <Callout variant="error">{t('oopsSomethingWentWrongFetchDespoitDetails')}</Callout>
  }
  return (
    <ProtocolContextProvider wallet={wallet}>
      <div
        data-testid="crypto-extended-details"
        className="bg-gray-01 p-11 border border-gray-03 max-w-3xl rounded"
      >
        <div className="flex flex-col sm:flex-row gap-6 pb-9 mr-12">
          <WalletQrCode />
          <div className="self-center">
            <ProtocolsRadioButtons />
            <WalletAddressDetails />
          </div>
        </div>
        {wallet.lookup && <CopyAllDetailsCrypto />}
        <WarningMessage />
      </div>
    </ProtocolContextProvider>
  )
}
